import { SkeletonItem } from "@/shared/ui/SkeletonItem";
import { TWHeight, TWWidth } from "@/styles/tw-types";

interface Props {
  length?: number;
  width?: TWWidth;
  height?: TWHeight;
}

export function SkeletonList({ length = 1, width, height = "h-6" }: Props) {
  return (
    <div className="flex-col-gap-4">
      {Array(length)
        .fill("")
        .map((_, index) => {
          return <SkeletonItem key={index} width={width} height={height} />;
        })}
    </div>
  );
}
